var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-20"},[_c('ToDoNotesIconSection'),_c('div',{staticClass:"font-bold text-center"},[_vm._v(" "+_vm._s(_vm.attestationTitle)+" ")]),(!_vm.memberAttestedThisPeriod())?_c('Body',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.attestationDescription)+" ")]):_vm._e(),_c('Attestation',{staticClass:"mt-10"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }